module.exports = __webpack_public_path__ + "static/img/d-commission.6f1428a4.png";